module.exports = __webpack_public_path__ + "img/seccionales.5da736a2.png";